import { useTheme } from 'styled-components';

export const IdentityIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Corner brackets - top left */}
      <path d="M2 6V3C2 2.44772 2.44772 2 3 2H6" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinecap="round" />
      {/* Corner brackets - top right */}
      <path d="M14 2H17C17.5523 2 18 2.44772 18 3V6" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinecap="round" />
      {/* Corner brackets - bottom left */}
      <path d="M2 14V17C2 17.5523 2.44772 18 3 18H6" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinecap="round" />
      {/* Corner brackets - bottom right */}
      <path
        d="M14 18H17C17.5523 18 18 17.5523 18 17V14"
        stroke={theme.iceBlue}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Person head */}
      <circle cx="10" cy="7" r="2.5" stroke={theme.iceBlue} strokeWidth="1.5" />
      {/* Person body */}
      <path
        d="M6 15C6 12.7909 7.79086 11 10 11C12.2091 11 14 12.7909 14 15"
        stroke={theme.iceBlue}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
